import { SkeletonLoader, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Title = styled.div`
  ${typographyV2.titleMd};
`;

export const CompaniesWrapper = styled.div`
  border: 1px solid var(--border-soft);
  border-radius: 8px;

  > *:not(:last-child) {
    border-bottom: 1px solid var(--border-soft);
  }
`;

export const StyledLoader = styled(SkeletonLoader).attrs({
  areas: [
    {
      styles: {
        width: '100%',
        height: '100px',
        borderRadius: '8px',
      },
    },
  ],
})``;
